import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "min-w-0 overflow-hidden rounded-2xl border border-[#DDE5EA] bg-gradient-to-br from-white via-white to-[#F2FBF9] shadow-[0_14px_40px_rgba(36,43,89,.08)]",
  "aria-label": "Painel visual coordenado"
}
const _hoisted_2 = { class: "flex flex-wrap items-start justify-between gap-3 border-b border-[#E8EEF0] p-5" }
const _hoisted_3 = { class: "mt-1 text-lg font-bold text-[#242B59]" }
const _hoisted_4 = { class: "rounded-full bg-[#48DDC3]/15 px-3 py-1 text-xs font-semibold text-[#168F7D]" }
const _hoisted_5 = { class: "grid min-w-0 grid-cols-1 gap-4 p-4 lg:grid-cols-2" }
const _hoisted_6 = {
  key: 0,
  class: "mx-4 mb-4 rounded-xl border border-[#BDEFE5] bg-[#F3FFFC] p-4"
}
const _hoisted_7 = { class: "mt-1 flex flex-wrap items-end justify-between gap-3" }
const _hoisted_8 = { class: "text-base font-semibold text-[#242B59]" }
const _hoisted_9 = { class: "text-xl font-bold text-[#168F7D]" }
const _hoisted_10 = {
  key: 0,
  class: "mt-3 flex flex-wrap gap-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[0] || (_cache[0] = _createElementVNode("p", { class: "text-[10px] font-bold uppercase tracking-[0.18em] text-[#168F7D]" }, " Análise coordenada ", -1 /* CACHED */)),
        _createElementVNode("h3", _hoisted_3, _toDisplayString($props.plan.title || 'Visão multidimensional'), 1 /* TEXT */)
      ]),
      _createElementVNode("span", _hoisted_4, _toDisplayString($props.plan.charts.length) + " perspectivas conectadas ", 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.plan.charts, (chart, index) => {
        return (_openBlock(), _createBlock($setup["AuraChartBlock"], {
          key: chart.id || index,
          chart: chart,
          "selected-label": $setup.selectedLabel,
          class: _normalizeClass(['min-w-0', index === 0 ? 'lg:col-span-2' : '']),
          onSelect: $setup.handleSelect
        }, null, 8 /* PROPS */, ["chart", "selected-label", "class"]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    ($setup.selectedDetails)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-[10px] font-bold uppercase tracking-[0.16em] text-[#168F7D]" }, " Foco selecionado ", -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("p", _hoisted_8, _toDisplayString($setup.formatAuraDateLabel($setup.selectedDetails.label)), 1 /* TEXT */),
            _createElementVNode("p", _hoisted_9, _toDisplayString($setup.formatAuraMetric($setup.selectedDetails.value, $setup.selectedDetails.unit)), 1 /* TEXT */)
          ]),
          ($setup.selectedDetails.series.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.selectedDetails.series, (item) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: item.name,
                    class: "rounded-full bg-white px-2.5 py-1 text-xs font-medium text-[#626468]"
                  }, _toDisplayString(item.name) + ": " + _toDisplayString($setup.formatAuraMetric(item.value, $setup.selectedDetails.unit)), 1 /* TEXT */))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}